import { features, seoStats } from '@/mocks/seo';

export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-accent-50/60">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        <div className="mb-4">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-accent-800 bg-white rounded-full whitespace-nowrap">
            SEO-Optimized Sourcing Hub
          </span>
        </div>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
          Everything About Mulebuy
          <br />
          Spreadsheet Systems
        </h2>

        <p className="mt-6 text-sm md:text-base text-foreground-600 font-sans max-w-2xl leading-relaxed">
          Most users searching for <strong>Mulebuy spreadsheet</strong> information face common problems: outdated spreadsheet lists, fragmented information across multiple sites, no clear comparison structure, and lack of safety verification. This platform solves that by building a centralized Mulebuy spreadsheet knowledge system designed for clarity, comparison, and decision-making.
        </p>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div key={feature} className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                <i className="ri-check-line text-accent-600 text-sm"></i>
              </div>
              <span className="text-sm text-foreground-700 font-sans">{feature}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
          {seoStats.map((stat) => (
            <div key={stat.label} className="text-center p-5 bg-white rounded-xl border border-accent-100/60">
              <div className="font-heading text-3xl md:text-4xl font-bold text-accent-700">{stat.value}</div>
              <div className="mt-1 text-xs text-foreground-500 font-sans">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl p-6 md:p-8 border border-accent-100/60">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
            What is a Mulebuy Spreadsheet?
          </h3>
          <p className="text-sm md:text-base text-foreground-600 font-sans leading-relaxed">
            A <strong>Mulebuy spreadsheet</strong> is a structured data system used to organize sourcing information, compare options, and streamline decision-making. In 2026, Mulebuy spreadsheet systems are commonly used for structured product tracking, supplier comparison workflows, data consolidation, and efficiency optimization. This website acts as a <strong>Mulebuy spreadsheet knowledge base</strong>, helping users understand and evaluate different systems.
          </p>
        </div>
      </div>
    </section>
  );
}